import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  workspaceBreadcrumbsAvatarAltText: {
    id: 'frontbucket.components.workspace.workspaceBreadcrumbsAvatarAltText',
    description:
      'Alt text for the breadcrumbs avatar that appears before workspace breadcrumbs text',
    defaultMessage: '{workspaceName} Avatar',
  },
});
